import makeStyles from '@mui/styles/makeStyles'
import { Paper, Theme, Typography } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import { IGameCharacter } from '../../../../../../../api/types/character'
import React from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { mutationDeleteCharacter, mutationNpcJoinGame } from '../../../../../../../api/mutations'
import { gameCharsQueryKey } from '../../../../../../../api/queries'
import { useGlobalError } from '../../../../../../../context/GlobalError'
import { ConfirmationDialog } from '../../../../../../../components/ConfirmationDialog/ConfirmationDialog'
import { NpcCharBadge } from '../NpcCharBadge/NpcCharBadge'
import { ActionIconButton } from '../../../../../../../components/ActionIconButton/ActionIconButton'
import { AddCircleOutlined } from '@mui/icons-material'
import { CreateCharacterModal } from '../../CreateCharacterModal/CreateCharacterModal'
import { extractMessage } from '../../../../../../../utils'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      marginRight: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5),
      marginBottom: theme.spacing(1),
      padding: theme.spacing(1),
    },
    badges: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
    },
  })
)

interface NpcCharBadgeListProps {
  game_id: number
  game_chars: IGameCharacter[]
  onCharSelect: (selected: IGameCharacter) => void
  clearSelection: () => void
  selected?: IGameCharacter
}

export const NpcCharBadgeList: React.FC<NpcCharBadgeListProps> = ({
  game_chars,
  onCharSelect,
  selected,
  game_id,
  clearSelection,
}) => {
  const classes = useStyles()
  const { addError } = useGlobalError()
  const queryClient = useQueryClient()
  const { mutate: npcJoinGame } = useMutation(
    (char_id: number) => mutationNpcJoinGame(char_id, game_id),
    {
      onError: (err: any) => {
        console.log(JSON.stringify(err))
        addError(extractMessage(err) || 'Nie udało się dodać postaci do gry', err?.status)
      },
      onSuccess: async () => {
        queryClient.invalidateQueries(gameCharsQueryKey(game_id))
      },
    }
  )
  const { mutate: deleteChar } = useMutation(
    (char_id: number) => mutationDeleteCharacter(char_id),
    {
      onError: (err: any) => {
        addError(extractMessage(err) || 'Nie udało się usunąć postaci', err?.status || 500)
      },
      onSuccess: async () => {
        queryClient.invalidateQueries(gameCharsQueryKey(game_id))
        clearSelection()
      },
    }
  )

  return (
    <Paper className={classes.paper}>
      <Typography color="text.secondary" variant="caption" display="block" gutterBottom>
        NPC
      </Typography>
      <div className={classes.badges}>
        {game_chars.map(c => (
          <ConfirmationDialog
            key={c.character.id}
            body={<div>{`Trwale usunąć postać ${c.character.name}?`}</div>}
          >
            {(confirm: any) => (
              <NpcCharBadge
                isSelected={selected === c}
                game_char={c}
                handleDelete={confirm(
                  (e: any) => () =>
                    new Promise(r => {
                      deleteChar(c.character.id)
                      r('ok')
                    })
                )}
                handleClick={() => onCharSelect(c)}
              />
            )}
          </ConfirmationDialog>
        ))}
        <CreateCharacterModal gmMode={true} afterCreate={char_id => npcJoinGame(char_id)}>
          {showModal => (
            <ActionIconButton size={'small'} onClick={showModal}>
              <AddCircleOutlined />
            </ActionIconButton>
          )}
        </CreateCharacterModal>
      </div>
    </Paper>
  )
}
